import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import all from "./all.json"

export default function Products({ language, setLanguage }) {
  return (
    <div>
      <div  id="Products">
        <div className="Products">   
          <div className="Product-overlay">
            <div>
                <Row>
                  {all.map((product) => (product.category === "product" ? 
                
                
                  <Col key={product.id} sm='12' md='12' lg='4' className='mb-3'>
                    <Card className='card-box-shadow' style={{ width: 'auto',minHeight:"1130px" }}>
                      <Card.Img variant="top" src={product.image} />
                        <Card.Body className='text-color'>
                          <Card.Title style={{ "fontWeight": "bold" }} className='under-line-card'> {language ? product.titleEn : product.titleNl}
                          </Card.Title>
                          <Card.Text className='product-paragraf'>
                            {language?product.descEn:product.descNl}
                          </Card.Text>
                        </Card.Body>
                    </Card>
                  </Col >
                  : null)
                )}
                </Row>  
          </div>    
        </div>
        </div>
      </div>
    </div>
  )
}